import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import "../Login/login.css";

const CheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const [countdown, setCountdown] = useState(30);
  const [resending, setResending] = useState(false);
  const { showAlert } = useAlert();

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleResend = async () => {
    if (!email) {
      navigate("/forgot-password");
      return;
    }

    setResending(true);
    try {
      await ApiMethods.post("auth/client/forgot-password/send-mail", {
        email,
      });
      setCountdown(30);
      showAlert("Email je ponovo poslat", "success");
    } catch (error) {
      showAlert("Greška pri ponovnom slanju emaila", "error");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="hf-login-root">
      <div className="hf-login-shell">
        <div className="hf-login-brand">
          <img
            className="hf-login-brand-logo"
            src="/img/hitfitlogo.jpg"
            alt="HitFit"
          />
          <h2 className="hf-login-brand-heading">
            Vođeni treninzi za rekreativce
          </h2>
        </div>

        <div className="hf-login-card">
          <div className="hf-login-card-inner hf-login-status-body">
            <div className="hf-login-logo-wrap">
              <img
                className="hf-login-logo"
                src="/img/hitfitlogo.jpg"
                alt="HitFit"
              />
            </div>

            <div className="hf-login-status-icon hf-login-status-info">
              <MailOutlineIcon fontSize="inherit" />
            </div>

            <h1 className="hf-login-title">Proverite email</h1>
            <p className="hf-login-subtitle">
              Poslali smo link za resetovanje lozinke na{" "}
              <strong>{email || "vaš email"}</strong>. Proverite prijemno
              sanduče i pratite uputstva da resetujete lozinku.
            </p>

            <div className="hf-login-actions">
              <button
                type="button"
                className="hf-login-submit"
                onClick={() => navigate("/login")}
              >
                Nazad na prijavu
              </button>
            </div>

            <p className="hf-login-resend">
              Niste primili email?{" "}
              {countdown > 0 ? (
                <span className="hf-login-resend-countdown">
                  Pošalji ponovo za {countdown}s
                </span>
              ) : (
                <button
                  type="button"
                  className="hf-login-resend-action"
                  onClick={handleResend}
                  disabled={resending}
                >
                  {resending ? "Slanje..." : "Pošalji ponovo"}
                </button>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
